const chatQuestions = {
  allProjects: [
    "What projects are currently active?",
    "What projects are ending soon?",
  ],
  project: [
    "Provide a summary of this project",
    "Provide a summary of the contents of each file",
  ],
  report: [
    "What are the main findings in this report?",
    "Are there any risks or issues highlighted in this report?",
  ],
};

export const getPredefinedQuestions = (pathname: string): string[] => {
  if (pathname.includes("/project/") && !pathname.includes("/report/"))
    return chatQuestions.project;
  if (pathname.includes("/report/")) return chatQuestions.report;
  return [];
};
